import { render, staticRenderFns } from "./Turibus.vue?vue&type=template&id=2a51a43c&scoped=true&"
import script from "./Turibus.vue?vue&type=script&lang=js&"
export * from "./Turibus.vue?vue&type=script&lang=js&"
import style0 from "./Turibus.vue?vue&type=style&index=0&id=2a51a43c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a51a43c",
  null
  
)

export default component.exports